import type { RefObject } from 'react';
import { t } from '@/lib/i18n';
import { PromotedEntitiesSection } from './PromotedEntitiesSection';
import {
  MessageBubble,
  type ChatMessage,
} from './AgentChatPageParts';

interface AgentChatTranscriptProps {
  sessionId: string;
  messages: ChatMessage[];
  promotionRefreshToken: number;
  onPromoted: () => void;
  onResolved: () => void;
  bottomRef: RefObject<HTMLDivElement | null>;
}

export function AgentChatTranscript({
  sessionId,
  messages,
  promotionRefreshToken,
  onPromoted,
  onResolved,
  bottomRef,
}: AgentChatTranscriptProps) {
  return (
    <div className="flex-1 overflow-y-auto space-y-3 pr-1 pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" data-testid="agent-chat-view">
      {messages.length === 0 && (
        <p className="text-sm text-slate-400 text-center mt-8" data-testid="agent-chat-empty">
          {t('Send a message to begin.')}
        </p>
      )}

      {messages.map((msg) => (
        <MessageBubble
          key={msg.id}
          msg={msg}
          sessionId={sessionId}
          onPromoted={onPromoted}
          onResolved={onResolved}
        />
      ))}

      {/* AC-M5-8: promoted entities section at bottom of transcript */}
      <PromotedEntitiesSection
        sessionId={sessionId}
        refreshToken={promotionRefreshToken}
      />
      <div ref={bottomRef} />
    </div>
  );
}
